import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { fetchRetrofitById } from '../api'
import { Retrofit } from '../models'

import { CACHE_TIME } from 'src/Libs/installations/constants'
import { usePortalQuery } from 'src/Libs/api'

interface UseRetrofitCheck {
  isLoading: boolean
  isError: boolean
  retrofitData: Retrofit | undefined
}

/**
 * Hook for the retrofit status check
 */
export const useRetrofitCheck = (serialnumber: string | undefined): UseRetrofitCheck => {
  const authFetch = useAuthFetchWithResponse()

  const retrofitQueryFunction = async (): Promise<Retrofit | null> => {
    const { error, hasErrors, value } = await fetchRetrofitById(serialnumber, authFetch)
    if (hasErrors) {
      throw error || new Error('An unexpected error occurred while fetching retrofit data')
    }

    return value
  }

  const {
    data: retrofitData,
    isLoading: isRetrofitLoading,
    isError: isRetrofitError,
  } = usePortalQuery({
    queryKey: ['retrofit-check', serialnumber],
    queryFn: retrofitQueryFunction,
    enabled: !!serialnumber,
    staleTime: CACHE_TIME,
  })

  return {
    retrofitData: retrofitData ?? undefined,
    isLoading: isRetrofitLoading,
    isError: isRetrofitError,
  }
}
